<template>
  <connexion-container :session-type="sessionType" layout-type="login">
    <notification></notification>
    <h1 class="h4 mb-4 d-none d-md-block">Connectez-vous</h1>
    <form class="access-form__form" @submit.prevent="signIn">
      <r-input
        v-model="params.email"
        :required="false"
        name="email"
        label="Email"
        icon="envelope-o"
        type="email"
        placeholder="Votre email"
        :error="error" />
      <r-input
        v-model="params.password"
        label="Mot de passe"
        icon="key"
        :type="password"
        placeholder="Votre mot de passe"
        :required="false"
        :error="error">
        <i class="has-icon-right__icon fa fa-eye" @click.prevent="switchType"></i>
      </r-input>
      <div class="form-group custom-control custom-checkbox">
        <input type="checkbox" v-model="remember" id="remember" class="custom-control-input">
        <label class="custom-control-label" for="remember">Se souvenir</label>
        <button type="button" data-toggle="modal" data-target="#forgottenPwd" class="access-form__link-pwd btn btn-link p-0">
          Mot de passe oublié ?
        </button>
      </div>
      <div class="access-form__btns row">
        <div class="col">
          <button class="btn-rounded btn btn-block" :class="'btn-outline-' + $mainColor" type="button" @click.stop="signUp">
            S'inscrire
          </button>
        </div>
        <div class="col">
          <s-button class="col" :loading="loading" @submit="signIn" :css-class="'btn-block btn-' + $mainColor">
            Connexion
          </s-button>
        </div>
      </div>
    </form>
    <a :href="$bestoveUrl" target="_blank" class="access-form__link-back thin" v-if="$appName === 'bestove'">
      <i class="access-form__icon fa fa-long-arrow-left" aria-hidden="true"></i>
      Retourner vers Bestove
    </a>
    <modal title="Mot de passe oublié" ref="forgotPassword">
      <p class="text-dark">Vous avez oublié votre mot de passe ? Pas de panique, rentrez votre mail ci-dessous et nous vous enverrons un lien ou vous pourrez créer votre nouveau mot de passe. </p>
      <vv-observer tag="form" @submit.prevent="resetPassword" ref="observer">
        <r-input
          v-model="email"
          name="email"
          icon="envelope-o"
          type="email"
          mode="passive"
          placeholder="Votre email"
          css-class="my-4 py-2"
          :error="error" />
        <div class="d-flex justify-content-center">
          <s-button type="submit" :css-class="'modal-pwd__submit btn-' + $mainColor" @submit="resetPassword" :loading="loading">
            Envoyer et réinitialiser mon mot de passe
          </s-button>
        </div>
      </vv-observer>
    </modal>
  </connexion-container>
</template>

<script>
import ConnexionContainer from '@/components/layout/ConnexionContainer'

export default {
  name: 'SignInForm',
  components: {
    ConnexionContainer
  },
  props: {
    sessionType: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      loading: false,
      params: {},
      email: '',
      password: 'password',
      remember: false,
      error: null
    }
  },
  mounted () {
    if (this.$route.params.notification) {
      this.$store.dispatch('setNotification', {
        message: this.$route.params.notification,
        mode: 'success'
      })
    }
  },
  methods: {
    switchType () {
      this.password = this.password === 'password' ? 'text' : 'password'
    },
    signIn () {
      this.loading = true
      this.$http.post(`/${this.sessionType}_auth/sign_in`, this.params).then(resp => {
        this.$store.commit(`SET_${this.sessionType.toUpperCase()}_LOADED`, true)
        this.$store.commit(`SET_CURRENT_${this.sessionType.toUpperCase()}`, resp.data.data)

        const authHeaders = _.pick(resp.headers, ['access-token', 'client', 'expiry', 'uid', 'session-type'])
        const contents = {
          tokens: authHeaders,
          id: resp.data.data.id,
          remember: this.remember
        }

        let expireDate = this.remember ? 14 : 1
        this.$cookie.set(`${this.sessionType}_session`, JSON.stringify(contents), { expires: expireDate })

        this.loading = false
        this.$router.push({ name: `${this.sessionType}Dashboard` })
      }).catch(err => {
        this.loading = false
        if (err.response.status === 401) {
          this.$store.dispatch('setNotification', {
            message: err.response.data.errors[0],
            mode: 'danger'
          })
        }
      })
    },
    async resetPassword () {
      const isValid = await this.$refs.observer.validate()
      if (isValid) {
        this.loading = true
        this.$http.post(`/${this.sessionType}_auth/password`, {
          email: this.email,
          config_name: this.sessionType,
          app_name: this.$appName,
          redirect_url: window.location.origin + this.$prefixUrl + this.sessionType + '/reset_password'
        }).then(() => {
          this.loading = false
          this.email = null
          let element = this.$refs.forgotPassword.$el
          element.click()
        }).catch(err => {
          this.loading = false
          this.error = null
          if (err.response.status === 404) {
            this.error = err.response.data.errors[0]
          }
        })
      }
    },
    signUp () {
      this.$router.push('sign_up')
    }
  },
  watch: {
    email (value) {
      if (_.isEmpty(value)) this.error = null
    }
  }
}
</script>
